import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {Http, RequestOptions, Response, Headers} from "@angular/http";
import {Customer} from "../../app/classes/customer";
import {COMPLETE_PAYLOAD} from "../../app/constants/config";
import {UserService} from "../../app/services/user.service";
import { Dialog } from '@capacitor/dialog';

/**
 * Generated class for the ReportErrorPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-report-error',
  templateUrl: 'report-error.html',
  providers: [
    UserService
  ]
})
export class ReportErrorPage {
  public feedback;
  public customer : any;
  constructor(public navCtrl: NavController,public navParams: NavParams, public http : Http, public userService : UserService) {
  this.customer =  Customer.cachedOrCreate(this.http);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportErrorPage');
  }

  submitFeedback(){
    this.userService.getAccount().then((account) => {
      let phonenumber = "Unknown";
      if (account) {
        phonenumber = account.phonenumber;
      }

      const headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');

      let options = new RequestOptions({ headers: headers });
      let body = new FormData();
      body.append('message', this.feedback);
      body.append('customer', this.customer.title);
      body.append('phonenumber', phonenumber);
      body.append('_submitKey', "4:user-reports:0");
      body.append("user-reports_submit", 'Submit');

      this.http.post("http://v1.mainorder.de/form-builder/user-reports/", body).map(this.handleResult).subscribe(
        success => this.handleSuccess(),
        err => this.handleErr()
      )
    });

  }

  handleErr(){
    Dialog.alert({
      message:'Oops, da ist was schief gelaufen. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
      title:null
    })
      .then(() => console.log('Dialog dismissed'))
      .catch(e => console.log('Error displaying dialog', e));
  }

  handleSuccess(){
    Dialog.alert({
      message: 'Danke für dein Feedback!',
      title: null
    })
      .then(() => console.log('Dialog dismissed'))
      .catch(e => console.log('Error displaying dialog', e));
    this.navCtrl.pop();
  }

  handleResult(res : Response){
    return res.text();
  }
}



// WEBPACK FOOTER //
// ./src/pages/report-error/report-error.ts